<div class="input-errors">
  <mg-text
    element="p"
    textAlign="left"
    variant="label-sm"
    [color]="$any(variantToColor)">
    <ng-content></ng-content>
  </mg-text>
</div>
